import { List, ListItem, ListSubSection } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function DemotePromoteMembersList({ membersToDemote, membersToPromote }) {
  const { t } = useTranslation()
  const hasMembersToDemote = membersToDemote.length > 0
  const hasMembersToPromote = membersToPromote.length > 0
  const useListSubSection = hasMembersToDemote && hasMembersToPromote
  return (
    <List>
      {useListSubSection && (
        <ListSubSection heading={t('action.demote', 'Demote')}>
          {membersToDemote.map((member) => (
            <ListItem
              key={member.memberCisId}
              primaryText={member.contactName}
              endElement={<ListItem.MetaText text={member.memberCisId.split('.')[2]} />}
            />
          ))}
        </ListSubSection>
      )}
      {hasMembersToDemote && !useListSubSection && (
        <>
          {membersToDemote.map((member) => (
            <ListItem
              key={member.memberCisId}
              primaryText={member.contactName}
              endElement={<ListItem.MetaText text={member.memberCisId.split('.')[2]} />}
            />
          ))}
        </>
      )}
      {useListSubSection && (
        <ListSubSection heading={t('action.promote', 'Promote')}>
          {membersToPromote.map((member) => (
            <ListItem
              key={member.memberCisId}
              primaryText={member.contactName}
              endElement={<ListItem.MetaText text={member.memberCisId.split('.')[2]} />}
            />
          ))}
        </ListSubSection>
      )}
      {hasMembersToPromote && !useListSubSection && (
        <>
          {membersToPromote.map((member) => (
            <ListItem
              key={member.memberCisId}
              primaryText={member.contactName}
              endElement={<ListItem.MetaText text={member.memberCisId.split('.')[2]} />}
            />
          ))}
        </>
      )}
    </List>
  )
}
